<template>
  <div class="w-100">
    <carousel
      :autoplayTimeout="7000"
      :loop="true"
      :autoplay="true"
      :paginationEnabled="false"
      :perPage="1"
      class="w-100 teste"
    >
      <slide v-for="(obj, i) in carousel" :key="i" class="w-100">
        <!-- <a :href="obj.link">
          <img class="w-100" :src="obj.image" alt="" />
        </a> -->
         <div>
          <a :href="obj.link">
            <video autoplay loop muted poster="https://www.virtex.com.br/postermovie.png">
              <source :src="obj.image" type="video/mp4" />
            </video>
          </a>
        </div>
      </slide>
    </carousel>
    <div class="countdown-mobile">
      <countdown class="countdownmobile" />
    </div>
    <div class="bfx">
    <img src="/logovtxapp.png" alt="VirteX App" />

    <div class="buttons">
      <a href="https://play.google.com/store/apps/details?id=com.virtex.mobile" target="_blank">
        <img src="/play-store-badge.png" alt="Android" target="_blank"/>
      </a>
      <a href="https://apps.apple.com/br/app/virtex-app/id1527307166" target="_blank">
        <img src="/app-store-badge.png" alt="iOs" target="_blank" />
      </a>
      </div>
    </div>

  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import getPageData from "../scripts/getPageData";
import Countdown from "./Countdown";
import carouselNotLoad from "../assets/carousel/poster.png";

export default {
  name: "CarouselHead",
  data() {
    return {
      carousel: []
    };
  },
  beforeCreate() {
    const gpd = getPageData();

    gpd.then(dt => {
      this.carousel = dt.carousel;
    });

    gpd.catch(() => {
      this.carousel = [...carouselNotLoad];
    });
  },
  components: {
    Carousel,
    Slide,
    Countdown
  }
};
</script>

<style scoped lang="scss">
.slide {
  display: block;
  width: 100%;
  height: 300px;
  background-color: #cc0000;
}

/* Black */
.links {
  display: flex;

  width: 100%;
  height: 100%;
  z-index: 5;
  background: transparent;
  position: absolute;
}

.links a {
  width: 100%;
  height: 100%;
}

.countdown {
  width: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 20px;
  color: #ffffff;
}

.countdown-mobile {
  height: 140px;
  background: #ffffff;
  color: #d40000;

  display: none;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(212, 0, 0, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 6px rgba(212, 0, 0, 0.3);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(212, 0, 0, 0.1);
  }
}

.bfx {
  display: flex;
  width: 100%;
  margin: 0 auto;
  align-items: center;
  flex-direction: column;
  justify-content: space-evenly;
  background: #0b0b0b;
  color: #ffffff;
  height: 350px;

  border-bottom: 1px solid #cd1316;

  background: url("/bg.png");
  background-size: cover;
}

.bfx img {
  width: 350px;
  height: auto;
  border-radius: 20px;
}

.bfx h3 {
  margin-top: -40px;
}

.buttons {
  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
  margin-bottom: 50px;
  width: 50%;
}

.buttons img {
  width: 200px;
  height: auto;
}

.buttons img:hover {
  box-shadow: rgba(255, 255, 255, 0.8) 0px 2px 4px 0px, rgba(255, 255, 255, 0.8) 0px 2px 16px 0px;
}

@media (max-width: 1080px) {
  .countdown {
    display: none;
  }

  .bfx {
    width: 100vw;
    flex-direction: column;
    height: 300px;
    background: #ffffff;
  }

  .bfx h1 {
    display: none;
  }

  .bfx h3 {
    text-align: center;
    width: 80%;
    font-size: 18px;
    color: rgba(212, 0, 0, 0.8);
    margin-top: 20px;
  }

  .bfx > img {
    width: 80%;
  }

  .buttons {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
  }

  .buttons a {
    display: block;
  }

  .buttons a img {
    width: 40vw;
    height: auto;
  }

  .buttons a img:hover {
    box-shadow: rgba(212, 0, 0, 0.8) 0px 2px 4px 0px, rgba(212, 0, 0, 0.8) 0px 2px 16px 0px;
  }

  .countdown-mobile {
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    height: 100px;
    width: 100%;
  }
}
</style>
